import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {downloadFileAPI} from '../../../utils';
import {BASE_URL} from '../../../utils/endpoints';
import {Button, Spinner} from 'react-bootstrap';

interface CampaignOffersDownloadButtonProps {
  campaignId?: number;
  label?: string;
  fileName?: string;
  className?: string;
}

export const CampaignOffersDownloadButton = ({
                                               campaignId,
                                               label,
                                               fileName = 'offers',
                                               className = 'mt-4 w-100 btn-outline-primary',
                                             }: CampaignOffersDownloadButtonProps) => {
  const {t} = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  if (!campaignId) {
    return null;
  }

  const handleDownload = async () => {
    setIsLoading(true);
    try {
      const url = `${BASE_URL}admin/offers/pdf/campaign/${campaignId}/offers/zip`;
      await downloadFileAPI(url, undefined, fileName);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      onClick={handleDownload}
      className={isLoading ? 'btn-primary mt-4 w-100' : className}
      disabled={isLoading}
    >
      {isLoading ? (
        <>
          <Spinner animation="border" size="sm" className="me-2"/>
          {label ?? t('general.downloading')}
        </>
      ) : (
        label ?? t('general.download')
      )}
    </Button>
  );
};
